import React from 'react';
import { ComponentFields } from '@sitecore-jss/sitecore-jss/types/layout/models';
import { Image, LinkField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { mapSharedPropertiesToFields } from 'common/getters';
import { SitecoreImage } from 'common/types/sitecore';
import { ComponentProps } from 'lib/component-props';

interface LogoSpotItem {
  link: LinkField;
  logo: SitecoreImage;
  id: string;
}

interface LogoSpot extends ComponentFields {
  // with the way how KSP placeholders are fetched it's not possible to use logos only
  [key: string]: any;
  logos: LogoSpotItem[];
}

type LogoSpotProps = ComponentProps & {
  fields: LogoSpot;
};

const LogoSpot: React.FC<LogoSpotProps> = ({ fields: fieldsShared }) => {
  const fields = mapSharedPropertiesToFields<LogoSpot>(fieldsShared);
  return (
    <ul className="container flex flex-wrap justify-center">
      {fields?.logos?.map(({ logo, link, id }) => {
        const LogoImage = <Image field={logo} />;
        return (
          <li key={id}>
            {logo?.value &&
              (link?.value?.href ? (
                <a href={link.value.href} className="block" target="_blank" rel="noreferrer">
                  {LogoImage}
                </a>
              ) : (
                LogoImage
              ))}
          </li>
        );
      })}
    </ul>
  );
};

export default withDatasourceCheck()(LogoSpot);
